/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * 返回语言。`zh` 返回中文（默认），`en` 返回英文。城市名翻译覆盖 7000+ 城市。生活指数（`indices`）目前仅支持中文。
 */
export const Lang = {
  Zh: "zh",
  En: "en",
} as const;
/**
 * 返回语言。`zh` 返回中文（默认），`en` 返回英文。城市名翻译覆盖 7000+ 城市。生活指数（`indices`）目前仅支持中文。
 */
export type Lang = ClosedEnum<typeof Lang>;

export const Lang$zodSchema = z.enum([
  "zh",
  "en",
]).describe(
  "返回语言。`zh` 返回中文（默认），`en` 返回英文。城市名翻译覆盖 7000+ 城市。生活指数（`indices`）目前仅支持中文。",
);

export type GetMiscWeatherRequest = {
  city?: string | undefined;
  adcode?: string | undefined;
  extended?: boolean | undefined;
  forecast?: boolean | undefined;
  hourly?: boolean | undefined;
  minutely?: boolean | undefined;
  indices?: boolean | undefined;
  lang?: Lang | undefined;
};

export const GetMiscWeatherRequest$zodSchema: z.ZodType<GetMiscWeatherRequest> =
  z.object({
    adcode: z.string().describe(
      "城市行政区划代码（如 `110000`），优先级高于 city。可选参数，不传时会尝试 IP 自动定位。",
    ).optional(),
    city: z.string().describe(
      "城市名称，支持中文（`北京`）和英文（`Tokyo`）。可选参数，不传时会尝试 IP 自动定位。",
    ).optional(),
    extended: z.boolean().describe(
      "返回扩展气象字段（体感温度、能见度、气压、紫外线、降水量、云量、空气质量指数及污染物分项数据）。",
    ).optional(),
    forecast: z.boolean().describe(
      "返回多天预报数据（最多7天），含白天夜间天气、风向风力、日出日落等。",
    ).optional(),
    hourly: z.boolean().describe(
      "返回逐小时预报（24小时），含温度、天气、风向风速、湿度、降水概率等。",
    ).optional(),
    indices: z.boolean().describe(
      "返回18项生活指数（穿衣、紫外线、洗车、晾晒、空调、感冒、运动、舒适度、出行、钓鱼、过敏、防晒、心情、啤酒、雨伞、交通、空气净化器、花粉）。",
    ).optional(),
    lang: Lang$zodSchema.default("zh"),
    minutely: z.boolean().describe(
      "返回分钟级降水预报（仅国内城市），每5分钟一个数据点，共24个。",
    ).optional(),
  });

/**
 * 天气服务暂时不可用。
 */
export type GetMiscWeatherServiceUnavailableResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetMiscWeatherServiceUnavailableResponseBody$zodSchema: z.ZodType<
  GetMiscWeatherServiceUnavailableResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe("天气服务暂时不可用。");

/**
 * 服务器内部错误。
 */
export type GetMiscWeatherInternalServerErrorResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetMiscWeatherInternalServerErrorResponseBody$zodSchema: z.ZodType<
  GetMiscWeatherInternalServerErrorResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe("服务器内部错误。");

/**
 * 城市未找到。
 */
export type GetMiscWeatherNotFoundResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetMiscWeatherNotFoundResponseBody$zodSchema: z.ZodType<
  GetMiscWeatherNotFoundResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe("城市未找到。");

/**
 * 参数无效。常见原因：`adcode` 格式非法、`lang` 非法（仅支持 zh/en）、参数值类型错误或参数组合无效。
 */
export type GetMiscWeatherBadRequestResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetMiscWeatherBadRequestResponseBody$zodSchema: z.ZodType<
  GetMiscWeatherBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe(
  "参数无效。常见原因：`adcode` 格式非法、`lang` 非法（仅支持 zh/en）、参数值类型错误或参数组合无效。",
);

/**
 * 空气污染物分项数据（extended=true 时返回，部分数据源可能不返回）
 */
export type AirPollutants = {
  pm25?: number | undefined;
  pm10?: number | undefined;
  o3?: number | undefined;
  no2?: number | undefined;
  so2?: number | undefined;
  co?: number | undefined;
};

export const AirPollutants$zodSchema: z.ZodType<AirPollutants> = z.object({
  co: z.number().optional(),
  no2: z.number().optional(),
  o3: z.number().optional(),
  pm10: z.number().optional(),
  pm25: z.number().optional(),
  so2: z.number().optional(),
}).describe("空气污染物分项数据（extended=true 时返回，部分数据源可能不返回）");

export type Forecast = {
  date?: string | undefined;
  week?: string | undefined;
  temp_max?: number | undefined;
  temp_min?: number | undefined;
  weather_day?: string | undefined;
  weather_night?: string | undefined;
  wind_dir_day?: string | undefined;
  wind_dir_night?: string | undefined;
  wind_scale_day?: string | undefined;
  wind_scale_night?: string | undefined;
  wind_speed_day?: number | undefined;
  humidity?: number | undefined;
  precip?: number | undefined;
  visibility?: number | undefined;
  uv_index?: number | undefined;
  sunrise?: string | undefined;
  sunset?: string | undefined;
};

export const Forecast$zodSchema: z.ZodType<Forecast> = z.object({
  date: z.string().optional(),
  humidity: z.number().optional(),
  precip: z.number().optional(),
  sunrise: z.string().optional(),
  sunset: z.string().optional(),
  temp_max: z.number().optional(),
  temp_min: z.number().optional(),
  uv_index: z.number().optional(),
  visibility: z.number().optional(),
  weather_day: z.string().optional(),
  weather_night: z.string().optional(),
  week: z.string().optional(),
  wind_dir_day: z.string().optional(),
  wind_dir_night: z.string().optional(),
  wind_scale_day: z.string().optional(),
  wind_scale_night: z.string().optional(),
  wind_speed_day: z.number().optional(),
});

export type HourlyForecast = {
  time?: string | undefined;
  temperature?: number | undefined;
  weather?: string | undefined;
  wind_direction?: string | undefined;
  wind_speed?: number | undefined;
  wind_scale?: string | undefined;
  humidity?: number | undefined;
  precip?: number | undefined;
  pressure?: number | undefined;
  cloud?: number | undefined;
  feels_like?: number | undefined;
  dew_point?: number | undefined;
  visibility?: number | undefined;
  pop?: number | undefined;
  uv_index?: number | undefined;
};

export const HourlyForecast$zodSchema: z.ZodType<HourlyForecast> = z.object({
  cloud: z.number().optional(),
  dew_point: z.number().optional(),
  feels_like: z.number().optional(),
  humidity: z.number().optional(),
  pop: z.number().optional(),
  precip: z.number().optional(),
  pressure: z.number().optional(),
  temperature: z.number().optional(),
  time: z.string().optional(),
  uv_index: z.number().optional(),
  visibility: z.number().optional(),
  weather: z.string().optional(),
  wind_direction: z.string().optional(),
  wind_scale: z.string().optional(),
  wind_speed: z.number().optional(),
});

export type GetMiscWeatherData = {
  time?: string | undefined;
  precip?: number | undefined;
  type?: string | undefined;
};

export const GetMiscWeatherData$zodSchema: z.ZodType<GetMiscWeatherData> = z
  .object({
    precip: z.number().optional(),
    time: z.string().optional(),
    type: z.string().optional(),
  });

/**
 * 分钟级降水预报（minutely=true 时返回，仅国内城市可用）
 */
export type MinutelyPrecip = {
  summary?: string | undefined;
  update_time?: string | undefined;
  data?: Array<GetMiscWeatherData> | undefined;
};

export const MinutelyPrecip$zodSchema: z.ZodType<MinutelyPrecip> = z.object({
  data: z.array(z.lazy(() => GetMiscWeatherData$zodSchema)).optional(),
  summary: z.string().optional(),
  update_time: z.string().optional(),
}).describe("分钟级降水预报（minutely=true 时返回，仅国内城市可用）");

/**
 * 穿衣指数
 */
export type Clothing = {
  level?: string | undefined;
  brief?: string | undefined;
  advice?: string | undefined;
};

export const Clothing$zodSchema: z.ZodType<Clothing> = z.object({
  advice: z.string().optional(),
  brief: z.string().optional(),
  level: z.string().optional(),
}).describe("穿衣指数");

/**
 * 紫外线指数
 */
export type Uv = {
  level?: string | undefined;
  brief?: string | undefined;
  advice?: string | undefined;
};

export const Uv$zodSchema: z.ZodType<Uv> = z.object({
  advice: z.string().optional(),
  brief: z.string().optional(),
  level: z.string().optional(),
}).describe("紫外线指数");

/**
 * 洗车指数
 */
export type CarWash = {
  level?: string | undefined;
  brief?: string | undefined;
  advice?: string | undefined;
};

export const CarWash$zodSchema: z.ZodType<CarWash> = z.object({
  advice: z.string().optional(),
  brief: z.string().optional(),
  level: z.string().optional(),
}).describe("洗车指数");

/**
 * 晾晒指数
 */
export type Drying = {
  level?: string | undefined;
  brief?: string | undefined;
  advice?: string | undefined;
};

export const Drying$zodSchema: z.ZodType<Drying> = z.object({
  advice: z.string().optional(),
  brief: z.string().optional(),
  level: z.string().optional(),
}).describe("晾晒指数");

/**
 * 空调开启指数
 */
export type AirConditioner = {
  level?: string | undefined;
  brief?: string | undefined;
  advice?: string | undefined;
};

export const AirConditioner$zodSchema: z.ZodType<AirConditioner> = z.object({
  advice: z.string().optional(),
  brief: z.string().optional(),
  level: z.string().optional(),
}).describe("空调开启指数");

/**
 * 感冒指数
 */
export type ColdRisk = {
  level?: string | undefined;
  brief?: string | undefined;
  advice?: string | undefined;
};

export const ColdRisk$zodSchema: z.ZodType<ColdRisk> = z.object({
  advice: z.string().optional(),
  brief: z.string().optional(),
  level: z.string().optional(),
}).describe("感冒指数");

/**
 * 运动指数
 */
export type Exercise = {
  level?: string | undefined;
  brief?: string | undefined;
  advice?: string | undefined;
};

export const Exercise$zodSchema: z.ZodType<Exercise> = z.object({
  advice: z.string().optional(),
  brief: z.string().optional(),
  level: z.string().optional(),
}).describe("运动指数");

/**
 * 舒适度指数
 */
export type Comfort = {
  level?: string | undefined;
  brief?: string | undefined;
  advice?: string | undefined;
};

export const Comfort$zodSchema: z.ZodType<Comfort> = z.object({
  advice: z.string().optional(),
  brief: z.string().optional(),
  level: z.string().optional(),
}).describe("舒适度指数");

/**
 * 出行指数
 */
export type Travel = {
  level?: string | undefined;
  brief?: string | undefined;
  advice?: string | undefined;
};

export const Travel$zodSchema: z.ZodType<Travel> = z.object({
  advice: z.string().optional(),
  brief: z.string().optional(),
  level: z.string().optional(),
}).describe("出行指数");

/**
 * 钓鱼指数
 */
export type Fishing = {
  level?: string | undefined;
  brief?: string | undefined;
  advice?: string | undefined;
};

export const Fishing$zodSchema: z.ZodType<Fishing> = z.object({
  advice: z.string().optional(),
  brief: z.string().optional(),
  level: z.string().optional(),
}).describe("钓鱼指数");

/**
 * 过敏指数
 */
export type Allergy = {
  level?: string | undefined;
  brief?: string | undefined;
  advice?: string | undefined;
};

export const Allergy$zodSchema: z.ZodType<Allergy> = z.object({
  advice: z.string().optional(),
  brief: z.string().optional(),
  level: z.string().optional(),
}).describe("过敏指数");

/**
 * 防晒指数
 */
export type Sunscreen = {
  level?: string | undefined;
  brief?: string | undefined;
  advice?: string | undefined;
};

export const Sunscreen$zodSchema: z.ZodType<Sunscreen> = z.object({
  advice: z.string().optional(),
  brief: z.string().optional(),
  level: z.string().optional(),
}).describe("防晒指数");

/**
 * 心情指数
 */
export type Mood = {
  level?: string | undefined;
  brief?: string | undefined;
  advice?: string | undefined;
};

export const Mood$zodSchema: z.ZodType<Mood> = z.object({
  advice: z.string().optional(),
  brief: z.string().optional(),
  level: z.string().optional(),
}).describe("心情指数");

/**
 * 啤酒指数
 */
export type Beer = {
  level?: string | undefined;
  brief?: string | undefined;
  advice?: string | undefined;
};

export const Beer$zodSchema: z.ZodType<Beer> = z.object({
  advice: z.string().optional(),
  brief: z.string().optional(),
  level: z.string().optional(),
}).describe("啤酒指数");

/**
 * 雨伞指数
 */
export type Umbrella = {
  level?: string | undefined;
  brief?: string | undefined;
  advice?: string | undefined;
};

export const Umbrella$zodSchema: z.ZodType<Umbrella> = z.object({
  advice: z.string().optional(),
  brief: z.string().optional(),
  level: z.string().optional(),
}).describe("雨伞指数");

/**
 * 交通指数
 */
export type Traffic = {
  level?: string | undefined;
  brief?: string | undefined;
  advice?: string | undefined;
};

export const Traffic$zodSchema: z.ZodType<Traffic> = z.object({
  advice: z.string().optional(),
  brief: z.string().optional(),
  level: z.string().optional(),
}).describe("交通指数");

/**
 * 空气净化器指数
 */
export type AirPurifier = {
  level?: string | undefined;
  brief?: string | undefined;
  advice?: string | undefined;
};

export const AirPurifier$zodSchema: z.ZodType<AirPurifier> = z.object({
  advice: z.string().optional(),
  brief: z.string().optional(),
  level: z.string().optional(),
}).describe("空气净化器指数");

/**
 * 花粉扩散指数
 */
export type Pollen = {
  level?: string | undefined;
  brief?: string | undefined;
  advice?: string | undefined;
};

export const Pollen$zodSchema: z.ZodType<Pollen> = z.object({
  advice: z.string().optional(),
  brief: z.string().optional(),
  level: z.string().optional(),
}).describe("花粉扩散指数");

/**
 * 18项生活指数（indices=true 时返回），每项包含 level（等级名称）、brief（简短描述）、advice（详细建议）
 */
export type LifeIndices = {
  clothing?: Clothing | undefined;
  uv?: Uv | undefined;
  car_wash?: CarWash | undefined;
  drying?: Drying | undefined;
  air_conditioner?: AirConditioner | undefined;
  cold_risk?: ColdRisk | undefined;
  exercise?: Exercise | undefined;
  comfort?: Comfort | undefined;
  travel?: Travel | undefined;
  fishing?: Fishing | undefined;
  allergy?: Allergy | undefined;
  sunscreen?: Sunscreen | undefined;
  mood?: Mood | undefined;
  beer?: Beer | undefined;
  umbrella?: Umbrella | undefined;
  traffic?: Traffic | undefined;
  air_purifier?: AirPurifier | undefined;
  pollen?: Pollen | undefined;
};

export const LifeIndices$zodSchema: z.ZodType<LifeIndices> = z.object({
  air_conditioner: z.lazy(() => AirConditioner$zodSchema).optional(),
  air_purifier: z.lazy(() => AirPurifier$zodSchema).optional(),
  allergy: z.lazy(() => Allergy$zodSchema).optional(),
  beer: z.lazy(() => Beer$zodSchema).optional(),
  car_wash: z.lazy(() => CarWash$zodSchema).optional(),
  clothing: z.lazy(() => Clothing$zodSchema).optional(),
  cold_risk: z.lazy(() => ColdRisk$zodSchema).optional(),
  comfort: z.lazy(() => Comfort$zodSchema).optional(),
  drying: z.lazy(() => Drying$zodSchema).optional(),
  exercise: z.lazy(() => Exercise$zodSchema).optional(),
  fishing: z.lazy(() => Fishing$zodSchema).optional(),
  mood: z.lazy(() => Mood$zodSchema).optional(),
  pollen: z.lazy(() => Pollen$zodSchema).optional(),
  sunscreen: z.lazy(() => Sunscreen$zodSchema).optional(),
  traffic: z.lazy(() => Traffic$zodSchema).optional(),
  travel: z.lazy(() => Travel$zodSchema).optional(),
  umbrella: z.lazy(() => Umbrella$zodSchema).optional(),
  uv: z.lazy(() => Uv$zodSchema).optional(),
}).describe(
  "18项生活指数（indices=true 时返回），每项包含 level（等级名称）、brief（简短描述）、advice（详细建议）",
);

/**
 * 查询成功！返回该地区的实时天气信息。
 */
export type GetMiscWeatherResponseBody = {
  province?: string | undefined;
  city?: string | undefined;
  adcode?: string | undefined;
  weather?: string | undefined;
  temperature?: number | undefined;
  wind_direction?: string | undefined;
  wind_power?: string | undefined;
  humidity?: number | undefined;
  report_time?: string | undefined;
  feels_like?: number | undefined;
  visibility?: number | undefined;
  pressure?: number | undefined;
  uv?: number | undefined;
  precipitation?: number | undefined;
  cloud?: number | undefined;
  aqi?: number | undefined;
  aqi_level?: number | undefined;
  aqi_category?: string | undefined;
  aqi_primary?: string | undefined;
  air_pollutants?: AirPollutants | undefined;
  temp_max?: number | undefined;
  temp_min?: number | undefined;
  forecast?: Array<Forecast> | undefined;
  hourly_forecast?: Array<HourlyForecast> | undefined;
  minutely_precip?: MinutelyPrecip | undefined;
  life_indices?: LifeIndices | undefined;
};

export const GetMiscWeatherResponseBody$zodSchema: z.ZodType<
  GetMiscWeatherResponseBody
> = z.object({
  adcode: z.string().optional(),
  air_pollutants: z.lazy(() => AirPollutants$zodSchema).optional(),
  aqi: z.number().optional(),
  aqi_category: z.string().optional(),
  aqi_level: z.number().optional(),
  aqi_primary: z.string().optional(),
  city: z.string().optional(),
  cloud: z.number().optional(),
  feels_like: z.number().optional(),
  forecast: z.array(z.lazy(() => Forecast$zodSchema)).optional(),
  hourly_forecast: z.array(z.lazy(() => HourlyForecast$zodSchema)).optional(),
  humidity: z.number().optional(),
  life_indices: z.lazy(() => LifeIndices$zodSchema).optional(),
  minutely_precip: z.lazy(() => MinutelyPrecip$zodSchema).optional(),
  precipitation: z.number().optional(),
  pressure: z.number().optional(),
  province: z.string().optional(),
  report_time: z.string().optional(),
  temp_max: z.number().optional(),
  temp_min: z.number().optional(),
  temperature: z.number().optional(),
  uv: z.number().optional(),
  visibility: z.number().optional(),
  weather: z.string().optional(),
  wind_direction: z.string().optional(),
  wind_power: z.string().optional(),
}).describe("查询成功！返回该地区的实时天气信息。");

export type GetMiscWeatherResponse =
  | GetMiscWeatherResponseBody
  | GetMiscWeatherBadRequestResponseBody
  | GetMiscWeatherNotFoundResponseBody
  | GetMiscWeatherInternalServerErrorResponseBody
  | GetMiscWeatherServiceUnavailableResponseBody;

export const GetMiscWeatherResponse$zodSchema: z.ZodType<
  GetMiscWeatherResponse
> = z.union([
  z.lazy(() => GetMiscWeatherResponseBody$zodSchema),
  z.lazy(() => GetMiscWeatherBadRequestResponseBody$zodSchema),
  z.lazy(() => GetMiscWeatherNotFoundResponseBody$zodSchema),
  z.lazy(() => GetMiscWeatherInternalServerErrorResponseBody$zodSchema),
  z.lazy(() => GetMiscWeatherServiceUnavailableResponseBody$zodSchema),
]);
